var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunicationsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.61,
    height: 32.687,
    viewBox: "0 0 29.61 32.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.366,52.261,381.625,50a1.055,1.055,0,1,0-1.492-1.492l-2.259,2.259a1.055,1.055,0,1,0,1.492,1.492Z",
    transform: "translate(-331.613 -44.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.08,176.733h-2.259a1.055,1.055,0,1,0,0,2.109h2.259a1.055,1.055,0,0,0,0-2.109Z",
    transform: "translate(-376.424 -165.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.221,4.369a1.055,1.055,0,0,0,1.055-1.055V1.055a1.055,1.055,0,0,0-2.109,0V3.314A1.055,1.055,0,0,0,282.221,4.369Z",
    transform: "translate(-240.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.409,350.56a1.055,1.055,0,0,0,0,1.492l4.519,4.519a1.055,1.055,0,0,0,1.492,0l1.767-1.767-6.01-6.01Z",
    transform: "translate(0 -327.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.273,386.038l-7.406,3.485,5.063,5.063a1.055,1.055,0,0,0,1.492,0l3.954-3.954a1.055,1.055,0,0,0,0-1.492Z",
    transform: "translate(-149.14 -362.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.253,48.5a.887.887,0,0,0-.819-.281.945.945,0,0,0-.683.565L74.841,67l5.307,5.752,16.811-8.574a1,1,0,0,0,.521-.74,1.064,1.064,0,0,0-.259-.887Z",
    transform: "translate(-47.173 -44.812)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationsvg);
export default __webpack_public_path__ + "static/media/COMMUNICATIONSVG.264e5c63cdebe0255de5141413ac8499.svg";
export { ForwardRef as ReactComponent };